// extracted by mini-css-extract-plugin
export var animationContainer = "_ns-0";
export var footer = "_ns-1";
export var gray = "_ns-2";
export var lineItem = "_ns-3";
export var lineItemImage = "_ns-4";
export var lineItemInfo = "_ns-5";
export var lineItemText = "_ns-6";
export var lineItems = "_ns-7";
export var modalContent = "_ns-8";
export var options = "_ns-9";
export var orderName = "_ns-a";
export var refundAmount = "_ns-b";